<template>
  <div class="details-grid">
    <div class="details-grid__table-responsive">
      <table class="details-grid__table">
        <thead>
          <tr class="details-grid__row details-grid__row--header">
            <th class="details-grid__th">
              <template v-if="model.isFromClaim">
                {{ getContentItem("claim") }}
              </template>
              <template v-else-if="model.isFromReturn">
                {{ getContentItem("return") }}
              </template>
              <template v-else>
                {{ getContentItem("source") }}
              </template>
            </th>
            <th class="details-grid__th details-grid__td--right">
              {{ getContentItem("Line") }}
            </th>
            <th class="details-grid__th">{{ getContentItem("PartNumber") }}</th>
            <th class="details-grid__th">{{ getContentItem("description") }}</th>
            <template v-if="model.isMcfa">
              <th class="details-grid__th">{{ getContentItem("poNumber") }}</th>
              <th class="details-grid__th">{{ getContentItem("htcCode") }}</th>
            </template>
            <th class="details-grid__th details-grid__td--right">
              {{ getContentItem("shipped") }}
            </th>
            <template v-if="canSeeAnyPrice">
              <th class="details-grid__th details-grid__td--right">
                {{ getContentItem("price") }}
              </th>
              <th v-if="model.isMcfa" class="details-grid__th details-grid__td--right">
                {{ getContentItem("coreCosts") }}
              </th>
              <th class="details-grid__th details-grid__td--right">
                {{ getContentItem("ExtPrice") }}
              </th>
            </template>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, index) in model.lineItems">
            <tr :key="index" class="details-grid__row" :class="{ 'details-grid__row--muted': item.type === 'Comment', 'details-grid__row--sub': item.isSubLine }">
              <td v-if="item.rowSpan" :rowspan="item.rowSpan + GetRowSpanForComments()" class="details-grid__td">
                <template v-if="model.relatedRoute">
                  <router-link :to="model.relatedRoute">
                    {{ item.source }}
                  </router-link>
                </template>
                <template v-else>
                  {{ item.source }}
                </template>
              </td>
              <template v-if="item.type === 'Comment'">
                <td class="details-grid__td details-grid__td--right details-grid__td--muted">
                  {{ item.line }}
                </td>
                <td class="details-grid__td details-grid__td--muted">
                  <em>Comment</em>
                </td>
                <td colspan="100%" class="details-grid__td details-grid__td--muted">
                  {{ item.description }}
                </td>
              </template>
              <template v-else>
                <td class="details-grid__td details-grid__td--right">
                  {{ item.line }}
                </td>
                <td class="details-grid__td">
                  <part-details-link :oem-part-code="item.partNumber" />
                </td>
                <td class="details-grid__td">{{ item.description }}</td>
                <template v-if="model.isMcfa">
                  <td class="details-grid__td">{{ item.poNumber }}</td>
                  <td class="details-grid__td">{{ item.htcCode }}</td>
                </template>
                <td class="details-grid__td details-grid__td--right">
                  {{ item.shipped }}
                </td>
                <template v-if="canSeeAnyPrice">
                  <td class="details-grid__td details-grid__td--right">
                    <currency-text
                      :amount="item.price"
                      :currency-code="model.currencyCode"
                    />
                  </td>
                  <td v-if="model.isMcfa" class="details-grid__td details-grid__td--right">
                    <currency-text
                      :amount="item.coreCost"
                      :currency-code="model.currencyCode"
                    />
                  </td>
                  <td class="details-grid__td details-grid__td--right">
                    <currency-text
                      :amount="item.extPrice"
                      :currency-code="model.currencyCode"
                    />
                  </td>
                </template>
              </template>
            </tr>
            <template v-for="comment in item.comments">
              <tr :key="comment" />
              <tr :key="comment" class="details-grid__row details-grid__row--muted">
                <td class="details-grid__td details-grid__td--right">
                  {{ item.line }}
                </td>
                <td class="details-grid__td">Comment</td>
                <td class="details-grid__td">{{ comment }}</td>
                <td colspan="3" class="details-grid__td" />
              </tr>
            </template>
          </template>
        </tbody>
      </table>
    </div>
        <div v-if="canSeeAnyPrice" class="details-grid__tfoot-container">
      <div class="details-grid__tfoot">
        <div class="details-grid__tfoot-row details-grid__row--total">
          <span class="details-grid__tfoot-label">{{ getContentItem("subtotal") }}:</span>
          <currency-text
            id="subtotal"
            :amount="model.subTotal"
            :currency-code="model.currencyCode"
            class="details-grid__tfoot-value"
          />
        </div>
        <div v-if="model.dealerClaimAmount" class="details-grid__tfoot-row details-grid__row-sub-fee">
          <span class="details-grid__tfoot-label">{{ getContentItem("ClaimAmount") }}:</span>
          <currency-text
            id="dealerClaimAmount"
            :amount="model.dealerClaimAmount"
            :currency-code="model.currencyCode"
            class="details-grid__tfoot-value"
          />
        </div>
        <div v-if="model.dealerServiceFee" class="details-grid__tfoot-row details-grid__row-sub-fee">
          <span class="details-grid__tfoot-label">{{ getContentItem("DealerServiceFee") }}:</span>
          <currency-text
            id="dealerServiceFee"
            :amount="model.dealerServiceFee"
            :currency-code="model.currencyCode"
            class="details-grid__tfoot-value"
          />
        </div>
        <div v-if="model.subTotalCores" class="details-grid__tfoot-row details-grid__row-sub-fee">
          <span class="details-grid__tfoot-label">{{ getContentItem("SubTotalCores") }}:</span>
          <currency-text
            id="subTotalCores"
            :amount="model.subTotalCores"
            :currency-code="model.currencyCode"
            class="details-grid__tfoot-value"
          />
        </div>
        <div v-if="model.total" class="details-grid__tfoot-row details-grid__row--total">
          <span class="details-grid__tfoot-label">{{ getContentItem("total") }}:</span>
          <currency-text
            id="total"
            :amount="model.total"
            :currency-code="model.currencyCode"
            class="details-grid__tfoot-value"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import { CurrencyText, PartDetailsLink } from "@/components";

  export default {
    name: "ModelGrid",
    components: {
      CurrencyText,
      PartDetailsLink,
    },
    props: {
      model: Object,
    },
    computed: {
      ...mapGetters(["getContentItem", "canSeeAnyPrice"]),
    },
    methods: {
      GetRowSpanForComments(){
        var count = 0;
        for(var i = 0; i < this.model.lineItems.length; i++){
          count += this.model.lineItems[i].comments?.length;
        }
        return count * 2;
      }
    }
  };
</script>

<style lang="scss" scoped>
.details-grid {
  width: 100%;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);
  padding: 16px;
  margin: 1rem 0rem;
}

.details-grid__table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.details-grid__th,
.details-grid__td {
  border-bottom: 1px solid #e3eaf3;
  padding: 10px 10px;
  text-align: left;
  vertical-align: middle;
  transition: background 0.2s;
}

.details-grid__th {
  background: #f4f6fb;
  font-weight: 600;
  color: #333;
  border-bottom: 2px solid #e3eaf3;
  letter-spacing: 0.02em;
}

.details-grid__td--right {
  text-align: right;
}

.details-grid__row {
  transition: background 0.2s;
}
.details-grid__row:hover {
  background: #eaf1fb;
}

.details-grid__row--sub {
  background: #f8fafc;
}

.details-grid__row--muted,
.details-grid__td--muted {
  color: #888;
  font-style: italic;
}

.details-grid__row--footer {
  background: #f4f6fb;
  font-weight: 500;
}
.details-grid__row--footer .details-grid__td {
  border-bottom: none;
}

.details-grid__row--total {
  background: #eaf1fb;
  font-weight: bold;
}
.details-grid__row--total .details-grid__td {
  border-top: 2px solid #e3eaf3;
}

.details-grid__row-sub-fee {
  padding-left: 2em;
  font-size: 0.92em;
  color: #4a5a6a;
}

.details-grid__inline-label {
  margin-right: 0.5em;
  color: #333;
  font-size: 0.95em;
  font-weight: 500;
}

/* Move totals to the right, outside the table */
.details-grid__tfoot-container {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.details-grid__tfoot {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  margin-top: 8px;
}

.details-grid__tfoot-row {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 240px;
  background: #f8fafc;
  border-radius: 4px;
  padding: 6px 14px;
  font-size: 0.92rem;
  font-weight: 500;
  box-shadow: none;
  margin-bottom: 2px;
}

.details-grid__row--total.details-grid__tfoot-row {
  background: #f4f6fb;
  font-weight: bold;
  border-top: 1px solid #e3eaf3;
}

.details-grid__tfoot-label {
  color: #444;
  font-weight: 700;
  margin-right: 10px;
  font-size: 0.92em;
  letter-spacing: 0.01em;
}

.details-grid__tfoot-value {
  color: #222;
  font-size: 0.92em;
  font-weight: 500;
}
</style>